var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgChevronLeftCircle(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.4244 4C7.8497 4 4.14114 7.58172 4.14114 12C4.14114 16.4183 7.8497 20 12.4244 20C16.9992 20 20.7077 16.4183 20.7077 12C20.7077 7.58172 16.9992 4 12.4244 4ZM2.07031 12C2.07031 6.47715 6.70601 2 12.4244 2C18.1429 2 22.7786 6.47715 22.7786 12C22.7786 17.5228 18.1429 22 12.4244 22C6.70601 22 2.07031 17.5228 2.07031 12ZM14.192 8.29289C14.5964 8.68342 14.5964 9.31658 14.192 9.70711L11.8179 12L14.192 14.2929C14.5964 14.6834 14.5964 15.3166 14.192 15.7071C13.7876 16.0976 13.1321 16.0976 12.7277 15.7071L9.62147 12.7071C9.21712 12.3166 9.21712 11.6834 9.62147 11.2929L12.7277 8.29289C13.1321 7.90237 13.7876 7.90237 14.192 8.29289Z",
    fill: "#292D32"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChevronLeftCircle);
export default __webpack_public_path__ + "static/media/chevron-left-circle.dfdf0926f3d48172cd3d87f4869e7d5c.svg";
export { ForwardRef as ReactComponent };